import { useEffect, useMemo, useState } from 'react';
import { isUndefined } from 'lodash';
import { LiqPrefLedgerItem } from 'api';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import liqPrefLedgerAfterCellChanged from './liqPrefLedgerAfterCellChanged';
import liqPrefLedgerConditions from './liqPrefLedgerConditions';
import liqPrefLedgerParser from './liqPrefLedgerParser';
import liqPrefLedgerReverseParser from './liqPrefLedgerReverseParser';
import liquidationPreferenceLedgerRowConfig from './liqPrefLedgerRowConfig';
import liqPrefLedgerValidations from './liqPrefLedgerValidations';

const useLiquidationPreferenceLedger = ({
  ledgerData,
  isDisabled = false,
  isUsingByExitDate = false,
  currentSecurity,
}: {
  ledgerData: LiqPrefLedgerItem[];
  isDisabled: boolean;
  isUsingByExitDate: boolean;
  currentSecurity?: { columnRef: string; investment_date: string };
}) => {
  const [spreadsheet, setSpreadsheet] = useState<SpreadsheetConfig | null>();

  const config = useMemo(() => liquidationPreferenceLedgerRowConfig({ isUsingByExitDate }), [isUsingByExitDate]);

  useEffect(() => {
    const cols = ledgerData;
    if (isUndefined(cols)) {
      return;
    }
    setSpreadsheet(
      new SpreadsheetConfig({
        columns: cols,
        name: 'LiquidationPreferenceLedger',
        afterCellChanged: liqPrefLedgerAfterCellChanged,
        totalParser: undefined,
        conditions: liqPrefLedgerConditions as any,
        tableData: {
          ...ledgerData,
          isDisabled,
          currentSecurity,
          isUsingByExitDate,
        },
        currencyFormatter: false,
        parser: liqPrefLedgerParser,
        reverseParser: liqPrefLedgerReverseParser as any,
        rowConfig: config,
        format: '',
        unitsFormatter: undefined,
        allowConfirmAndDeleteColumn: true,
        allowDeleteColumn: true,
        customValidations: liqPrefLedgerValidations as any,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ledgerData, config, currentSecurity]);

  return {
    spreadsheet,
  };
};

export default useLiquidationPreferenceLedger;
